import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ChallengeModal from '../../common/ChallengeModal';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  container: document.getElementById('select-dropdown-wrapper'),
};

const names = ['Accept', 'Decline'];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    justifyContent: 'center',
  };
}

export default function CampRequestSelectBox({
  handleStatusChange,
  handleDelete,
  showDeleteConfirm,
  setShowDeleteConfirm,
}) {
  const theme = useTheme();
  const [personName, setPersonName] = React.useState(''); // Keep it as an empty string for the placeholder

  const handleChange = (event) => {
    const { value } = event.target;
    if (value === 'Accept') {
      handleStatusChange('accept');
      setPersonName(value);
    }
    if (value === 'Decline') {
      setShowDeleteConfirm(true);
    }
  };

  const handleCloseDeleteConfirm = () => {
    setShowDeleteConfirm(false);
  };

  const handleDeleteRequest = () => {
    setPersonName('Decline');
    handleDelete();
  };

  return (
    <div id="select-dropdown-wrapper">
      <ChallengeModal
        handleClose={handleCloseDeleteConfirm}
        handleAction={handleDeleteRequest}
        show={showDeleteConfirm}
        type="confirm"
        level="warning"
        button1Label="Delete"
        button2Label="Cancel"
      >
        <div>
          <span>Are you sure you want to delete this request?</span>
        </div>
      </ChallengeModal>
      <FormControl sx={{ width: 200 }}>
        <Select
          value={personName}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          className="camp-request-select-box"
          renderValue={(selected) => {
            if (selected === '') {
              return (
                <em
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 600,
                    color: '#321b6d',
                    fontSize: '14px',
                  }}
                >
                  Select
                </em>
              );
            }
            return selected;
          }}
          sx={{
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none', // Remove the border when focused
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent', // No border color on hover
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent', // No border by default
            },
          }}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
